import classNames from "classnames";

interface IAvisValueRowProps {
  rowTitle?: string;
  rowValue?: string | React.ReactNode;
  rowTitleCols?: number;
  rowValueCols?: number;
  className?: string;
}
export function AvisValueRow(props: Readonly<IAvisValueRowProps>) {
  const { rowTitle, rowValue, rowTitleCols, rowValueCols, className } = props;

  const classTitleCols = rowTitleCols ? "col-" + rowTitleCols : "col";
  const classValueCols = rowValueCols ? "col-" + rowValueCols : "col";
  const classNameTitle = classNames("row-title", classTitleCols);
  const classNameValue = classNames("row-value", classValueCols);
  const classNameContainerRow = classNames("avis-value-row", "grid", className);
  return (
    <div className={classNameContainerRow}>
      <div className={classNameTitle}>{rowTitle}</div>
      <div className={classNameValue}>{rowValue}</div>
    </div>
  );
}
